import { useState } from 'react';
import { useLang } from '@/context/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, ArrowUpRight } from 'lucide-react';

const navItems = ['home', 'services', 'portfolio', 'about', 'contact'];

export default function Header() {
  const { lang, toggleLang, t } = useLang();
  const [mobileOpen, setMobileOpen] = useState(false);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMobileOpen(false);
  };

  return (
    <>
      <header
        data-testid="main-header"
        className="fixed top-0 left-0 right-0 z-50 bg-zinc-950/70 backdrop-blur-xl border-b border-white/5"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-16 lg:h-20">
          <button
            data-testid="logo-btn"
            onClick={() => scrollTo('home')}
            className="shrink-0"
          >
            <img src="https://customer-assets.emergentagent.com/job_madison-fred-design/artifacts/zy0qofhd_Copilot_20260414_133202.png" alt="MadisonFred" className="h-14 lg:h-16 w-auto" />
          </button>

          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {navItems.map((item) => (
              <button
                key={item}
                data-testid={`nav-${item}`}
                onClick={() => scrollTo(item)}
                className="text-sm font-manrope text-zinc-400 hover:text-zinc-50 transition-colors duration-300 tracking-wide uppercase"
              >
                {t(`nav.${item}`)}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-4">
            <button
              data-testid="lang-toggle"
              onClick={toggleLang}
              className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 hover:text-zinc-50 transition-colors border border-white/10 px-3 py-1.5"
            >
              {lang === 'en' ? 'FR' : 'EN'}
            </button>

            <button
              data-testid="mobile-menu-btn"
              className="md:hidden text-zinc-50"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              {mobileOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </header>

      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-40 bg-zinc-950/95 backdrop-blur-2xl flex flex-col items-center justify-center gap-8"
          >
            {navItems.map((item, i) => (
              <motion.button
                key={item}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}
                data-testid={`mobile-nav-${item}`}
                onClick={() => scrollTo(item)}
                className="text-3xl font-outfit font-bold text-zinc-50 hover:text-zinc-400 transition-colors flex items-center gap-3"
              >
                {t(`nav.${item}`)}
                <ArrowUpRight size={20} className="text-zinc-500" />
              </motion.button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
